(function () {
  'use strict';

  angular
    .module('factories.spinnerHelper', [
      'factories.nativeBridge',
      'factories.authProvider',
      'factories.mobileHelper',
      'factories.alert'])
    .factory('SpinnerHelper', SpinnerHelper);

  SpinnerHelper.$inject = ['NativeBridge', 'MobileHelper', 'Auth', '$timeout', 'Alert', 'gettext', 'translationService'];

  function SpinnerHelper(NativeBridge, MobileHelper, Auth, $timeout, Alert, gettext, translationService) {
    var failsafeTimer;
    var translate = translationService.sprintf;

    function showLoadingSpinner() {
      startSpinnerFailsafe();
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("showSpinner");
      $('#spinner').addClass('spinner');
      $('#mainView').css('opacity', 0.3);
      $('#mainView').addClass('spinner-visible');
    }

    function showMinorSpinner() {
      startSpinnerFailsafe();
      $('#spinner').addClass('spinner');
      $('#mainView').addClass('spinner-visible');
    }

    function hideAllSpinners() {
      stopSpinnerFailsafe();
      $('#spinner').removeClass('spinner');
      $('#mainView').removeClass('spinner-visible');
      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler("hideSpinner");
      $('#mainView').css('opacity', 1);
    }

    function startSpinnerFailsafe() {
      stopSpinnerFailsafe();
      failsafeTimer = $timeout(activateSelfDestruct, mfConfig.spinnerFailsafe);
    }

    function stopSpinnerFailsafe() {
      $timeout.cancel(failsafeTimer);
    }

    function activateSelfDestruct() {
      throw new Error('FailSafe Timeout');
      hideAllSpinners();
      Alert.show(translate(gettext('Cannot connect to Mindflash.')), translate(gettext('Please check your network connection and try again.')));
      Auth.logoutSaveEmail();
    }

    return {
      showLoadingSpinner: showLoadingSpinner,
      showMinorSpinner: showMinorSpinner,
      hideAllSpinners: hideAllSpinners
    };
  }

})();
